var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvisory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6376 0.677549C13.4149 0.667239 13.1843 0.652807 12.9625 0.678405C9.62372 1.06383 9.12469 5.98276 12.4029 7.01516C12.6225 7.08434 12.8441 7.11682 13.0701 7.15565C13.2883 7.16605 13.5094 7.17498 13.7267 7.14976C17.1013 6.75809 17.5259 1.7746 14.2067 0.797013C14.0186 0.74166 13.8283 0.71842 13.6376 0.677549Z",
    fill: "#0044c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.847 7.64595L15.797 7.64062C15.7398 7.68393 15.7014 7.75365 15.6617 7.81323L14.1838 10.333C14.0498 9.92547 13.831 8.54247 13.8095 8.13248L12.9446 8.14637L12.4984 10.324L10.9372 7.64272C8.65839 7.88411 6.88038 9.98694 6.60835 12.261C6.57867 12.5088 6.57622 12.768 6.56616 13.0177L6.566 13.508L20.0938 13.5017L20.0925 12.7551C20.0807 10.1346 18.4471 8.35797 16.0063 7.67372C15.9539 7.65905 15.901 7.65179 15.847 7.64595Z",
    fill: "#0044c6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8965 14.2914L3.69299 14.286C3.34036 14.286 2.98131 14.2707 2.62974 14.2949C1.1505 14.3964 0.18611 16.0194 0.915655 17.3993L0.936329 17.4385C1.27176 18.0374 1.89446 18.3254 2.51632 18.4971L4.10015 26.0042C4.09353 26.1371 4.3428 27.1686 4.3831 27.3119L21.9425 27.3121C22.3291 27.3151 22.2609 27.4265 22.3339 27.1155L24.0872 18.9316C24.1971 18.3883 24.0565 18.516 24.5608 18.3848C26.477 17.8865 26.5098 14.9288 24.4783 14.3641C24.2905 14.3119 24.0895 14.3082 23.8965 14.2914Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisory);
export default __webpack_public_path__ + "static/media/Advisory.c4ed252268552d2080f4ab7056edbef4.svg";
export { ForwardRef as ReactComponent };